export enum Locale {
  EN = 'en',
  FR = 'fr',
}

export interface Field {
  value?: string;
  error?: boolean;
}

// Service.ts throws the parsed JSON error body, so both `code` and `message`
// are readable in a React Query `onError`.
export interface ApiError {
  code?: string;
  message?: string;
  status?: number;
  memberId?: number;
}
